var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useLanguage } from '@base/LanguageProvider';
import { TagType, } from '@common/api';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { CustomColumnType, isAccountTag, isDimensionTagJsonData, isTableTagJsonData, } from '@data/tag/types';
import Manager from '@shared/modal/Manager';
import { Confirmation } from '@shared/modal/Simple';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { handleApiErrorMessage } from '@util/message';
export var TagEditorColumnType;
(function (TagEditorColumnType) {
    TagEditorColumnType["Default"] = "Default";
    TagEditorColumnType["Custom"] = "Custom";
    TagEditorColumnType["Connection"] = "Connection";
    TagEditorColumnType["AddNewButton"] = "AddNewButton";
    TagEditorColumnType["Formula"] = "Formula";
    TagEditorColumnType["Dimensions"] = "Dimensions";
})(TagEditorColumnType || (TagEditorColumnType = {}));
export function mapTagRepresentationToEditTagData(tag) {
    var e = {
        id: tag.id,
        name: tag.name,
        description: tag.description,
        jsonData: isDimensionTagJsonData(tag.jsonData) ? tag.jsonData : null,
    };
    if (tag.expression !== undefined) {
        e.expression = tag.expression;
    }
    if (tag.dimensionTagIds !== undefined) {
        e.dimensionTagIds = tag.dimensionTagIds;
    }
    return e;
}
var KNOB_IDENTIFICATOR = '/knob:';
export function useTagTable() {
    var e_1, _a, _b, _c, e_2, _d, e_3, _e;
    var _f, _g;
    var _h = useLanguage(), L = _h.L, excelLocalizedNumberFormat = _h.excelLocalizedNumberFormat, parseLocaleNumber = _h.parseLocaleNumber, formatLocaleDate = _h.formatLocaleDate, parseLocaleDate = _h.parseLocaleDate;
    var _j = __read(useState(null), 2), selectedTagId = _j[0], setSelectedTagId = _j[1];
    var tagData = useTagContext().tagData;
    var _k = useTagActions(), editTagJsonData = _k.editTagJsonData, batchDeleteTags = _k.batchDeleteTags;
    var selectedTag = tagData.tagById[selectedTagId !== null && selectedTagId !== void 0 ? selectedTagId : -1];
    var tagsToShow = selectedTagId !== null ? tagData.tagsByParentId[selectedTagId === 0 ? 'null' : selectedTagId] : [];
    function batchDeleteTagsHandler(tagIdsToDelete) {
        return __awaiter(this, void 0, void 0, function () {
            var tagNames;
            var _this = this;
            return __generator(this, function (_a) {
                tagNames = tagIdsToDelete.map(function (tagId) { var _a, _b; return (_b = (_a = tagData.tagById[tagId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; });
                Manager.renderModal(React.createElement(Confirmation, { width: 500, title: tagIdsToDelete.length === 1 ? L('Confirm tag remove') : L('Confirm tags remove'), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (tagIdsToDelete.length > 1) {
                                        startGlobalLoading();
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, 4, 5]);
                                    return [4 /*yield*/, batchDeleteTags(tagIdsToDelete)];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 5];
                                case 3:
                                    err_1 = _a.sent();
                                    handleApiErrorMessage(err_1);
                                    return [3 /*break*/, 5];
                                case 4:
                                    if (tagIdsToDelete.length > 1) {
                                        stopGlobalLoading();
                                    }
                                    return [7 /*endfinally*/];
                                case 5: return [2 /*return*/];
                            }
                        });
                    }); } },
                    React.createElement("span", null, tagIdsToDelete.length < 50
                        ? "".concat(tagIdsToDelete.length === 1
                            ? L('Are you sure you want to remove tag')
                            : L('Are you sure you want to remove tags:'), " ").concat(tagNames.join(', '), " ?")
                        : "".concat(L('Are you sure you want to remove'), " ").concat(tagIdsToDelete.length, " ").concat(L('tags')))));
                return [2 /*return*/];
            });
        });
    }
    function removeCustomColumn(uniqueId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var jsonData, newHeaders;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (selectedTag === undefined) {
                            return [2 /*return*/];
                        }
                        jsonData = (_a = selectedTag.jsonData) !== null && _a !== void 0 ? _a : { headers: [] };
                        if (!isTableTagJsonData(jsonData)) {
                            return [2 /*return*/];
                        }
                        newHeaders = jsonData.headers.filter(function (h) { return h.uniqueId !== uniqueId; });
                        return [4 /*yield*/, editTagJsonData(selectedTag.id, __assign(__assign({}, jsonData), { headers: newHeaders }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function renameCustomColumn(uniqueId, newName) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var jsonData, headersCopy, renamedHeaderIndex;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (selectedTag === undefined) {
                            return [2 /*return*/];
                        }
                        jsonData = (_a = selectedTag.jsonData) !== null && _a !== void 0 ? _a : { headers: [] };
                        if (!isTableTagJsonData(jsonData)) {
                            return [2 /*return*/];
                        }
                        headersCopy = __spreadArray([], __read(jsonData.headers), false);
                        renamedHeaderIndex = headersCopy.findIndex(function (h) { return h.uniqueId === uniqueId; });
                        if (renamedHeaderIndex >= 0) {
                            headersCopy[renamedHeaderIndex] = __assign(__assign({}, headersCopy[renamedHeaderIndex]), { name: newName });
                        }
                        return [4 /*yield*/, editTagJsonData(selectedTag.id, __assign(__assign({}, jsonData), { headers: headersCopy }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    // fill up rows with tag data
    var rows = [];
    try {
        for (var _l = __values(tagsToShow !== null && tagsToShow !== void 0 ? tagsToShow : []), _m = _l.next(); !_m.done; _m = _l.next()) {
            var tag = _m.value;
            if (tag.type === TagType.Dimension || tag.type === TagType.Account) {
                rows.push({
                    id: tag.id,
                    name: tag.name,
                    expanded: false,
                    depth: 0,
                    hasChildren: false,
                    tag: tag,
                    connectedTagColumns: [],
                    disabled: false,
                });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // fill up columns
    var shownColumns = [];
    // add NAME column
    shownColumns.push({
        type: TagEditorColumnType.Default,
        key: 'name',
        readonly: false,
        name: L('Name'),
        getValue: function (tagRow) { return tagRow.name; },
        applyChange: function (editTagData, newValue) {
            if (newValue !== '' && !newValue.includes(KNOB_IDENTIFICATOR)) {
                return __assign(__assign({}, editTagData), { name: newValue });
            }
        },
    });
    // add DESCRIPTION column
    shownColumns.push({
        type: TagEditorColumnType.Default,
        key: 'description',
        readonly: false,
        name: L('Description'),
        getValue: function (tagRow) { var _a; return (_a = tagRow.tag.description) !== null && _a !== void 0 ? _a : ''; },
        applyChange: function (editTagData, newValue) {
            if (!newValue.includes(KNOB_IDENTIFICATOR)) {
                return __assign(__assign({}, editTagData), { description: newValue });
            }
        },
    });
    var hasAccountTags = tagsToShow === null || tagsToShow === void 0 ? void 0 : tagsToShow.some(function (t) { return isAccountTag(t); });
    if (hasAccountTags) {
        // add FORMULA column
        shownColumns.push({
            type: TagEditorColumnType.Formula,
            key: 'formula',
            readonly: false,
            name: L('Formula'),
            getValue: function (tagRow) { var _a; return (_a = tagRow.tag.expression) !== null && _a !== void 0 ? _a : ''; },
            applyChange: function (editTagData, newValue) {
                var _a;
                if (((_a = editTagData.expression) !== null && _a !== void 0 ? _a : '') !== newValue) {
                    return __assign(__assign({}, editTagData), { expression: newValue });
                }
            },
        });
        // add DIMENSION column
        shownColumns.push({
            type: TagEditorColumnType.Dimensions,
            key: 'dimensions',
            readonly: false,
            name: L('Dimensions'),
            getValue: function (tagRow) { var _a, _b; return (_b = (_a = tagRow.tag.dimensionTagIds) === null || _a === void 0 ? void 0 : _a.map(function (t) { var _a; return (_a = tagData.tagById[t]) === null || _a === void 0 ? void 0 : _a.name; }).join(', ')) !== null && _b !== void 0 ? _b : ''; },
            applyChange: function (editTagData, newValue) {
                var e_4, _a;
                var tagNames = newValue.split(', ');
                var tagIds = [];
                try {
                    for (var tagNames_1 = __values(tagNames), tagNames_1_1 = tagNames_1.next(); !tagNames_1_1.done; tagNames_1_1 = tagNames_1.next()) {
                        var tagName = tagNames_1_1.value;
                        var tagsWithName = tagData.tagsByLowercase[tagName.toLowerCase()];
                        if (tagsWithName !== undefined && tagsWithName.length === 1) {
                            tagIds.push(tagsWithName[0].id);
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (tagNames_1_1 && !tagNames_1_1.done && (_a = tagNames_1.return)) _a.call(tagNames_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return __assign(__assign({}, editTagData), { dimensionTagIds: tagIds });
            },
        });
    }
    var customColumnGetValueMap = (_b = {},
        _b[CustomColumnType.TEXT] = function (headerUniqueId) { return function (tagRow) {
            var jsonData = tagRow.tag.jsonData;
            if (jsonData === null || !isDimensionTagJsonData(jsonData)) {
                return '';
            }
            else {
                var value = jsonData.values[headerUniqueId];
                if (value === undefined || value === null) {
                    return '';
                }
                if (typeof value === 'string') {
                    return value;
                }
                else {
                    return '';
                }
            }
        }; },
        _b[CustomColumnType.NUMBER] = function (headerUniqueId) { return function (tagRow) {
            var jsonData = tagRow.tag.jsonData;
            if (jsonData === null || !isDimensionTagJsonData(jsonData)) {
                return '';
            }
            else {
                var value = jsonData.values[headerUniqueId];
                if (value === undefined || value === null) {
                    return '';
                }
                if (typeof value === 'number') {
                    return excelLocalizedNumberFormat(value);
                }
                else {
                    return '';
                }
            }
        }; },
        _b[CustomColumnType.DATE] = function (headerUniqueId) { return function (tagRow) {
            var jsonData = tagRow.tag.jsonData;
            if (jsonData === null || !isDimensionTagJsonData(jsonData)) {
                return '';
            }
            else {
                var value = jsonData.values[headerUniqueId];
                if (value === undefined || value === null) {
                    return '';
                }
                if (typeof value === 'string') {
                    return formatLocaleDate(new Date(value));
                }
                else {
                    return '';
                }
            }
        }; },
        _b[CustomColumnType.FILE] = function (headerUniqueId) { return function (tagRow) {
            var jsonData = tagRow.tag.jsonData;
            if (jsonData === null || !isDimensionTagJsonData(jsonData)) {
                return '';
            }
            else {
                var value = jsonData.values[headerUniqueId];
                if (value === undefined || value === null) {
                    return '';
                }
                if (typeof value === 'object') {
                    return value.filename;
                }
                else {
                    return '';
                }
            }
        }; },
        _b);
    var customColumnUpdateValuesMap = (_c = {},
        _c[CustomColumnType.TEXT] = function (headerUniqueId) { return function (editTagData, newValue) {
            var _a;
            var _b;
            var jsonData = (_b = editTagData.jsonData) !== null && _b !== void 0 ? _b : { values: {} };
            if (!isDimensionTagJsonData(jsonData)) {
                return;
            }
            var newUsedValue = newValue === '' ? null : newValue;
            return __assign(__assign({}, editTagData), { jsonData: __assign(__assign({}, jsonData), { values: __assign(__assign({}, jsonData.values), (_a = {}, _a[headerUniqueId] = newUsedValue, _a)) }) });
        }; },
        _c[CustomColumnType.NUMBER] = function (headerUniqueId) { return function (editTagData, newValue) {
            var _a;
            var _b;
            var jsonData = (_b = editTagData.jsonData) !== null && _b !== void 0 ? _b : { values: {} };
            if (!isDimensionTagJsonData(jsonData)) {
                return;
            }
            var newUsedValue = null;
            if (newValue !== '') {
                var parsedNumber = parseLocaleNumber(newValue);
                if (parsedNumber !== null) {
                    newUsedValue = parsedNumber;
                }
                else {
                    toast.error(L('Error parsing number'));
                    return;
                }
            }
            return __assign(__assign({}, editTagData), { jsonData: __assign(__assign({}, jsonData), { values: __assign(__assign({}, jsonData.values), (_a = {}, _a[headerUniqueId] = newUsedValue, _a)) }) });
        }; },
        _c[CustomColumnType.DATE] = function (headerUniqueId) { return function (editTagData, newValue) {
            var _a;
            var _b;
            var jsonData = (_b = editTagData.jsonData) !== null && _b !== void 0 ? _b : { values: {} };
            if (!isDimensionTagJsonData(jsonData)) {
                return;
            }
            var newUsedValue = null;
            if (newValue !== '') {
                var parsedDate = parseLocaleDate(newValue);
                if (parsedDate !== null) {
                    newUsedValue = parsedDate.toISOString();
                }
                else {
                    toast.error(L('Error parsing date'));
                    return;
                }
            }
            return __assign(__assign({}, editTagData), { jsonData: __assign(__assign({}, jsonData), { values: __assign(__assign({}, jsonData.values), (_a = {}, _a[headerUniqueId] = newUsedValue, _a)) }) });
        }; },
        _c[CustomColumnType.FILE] = function (headerUniqueId) { return function (editTagData, newValue) {
            toast.error(L('Please use context menu for updating file column'));
            return undefined;
        }; },
        _c);
    // add CUSTOM columns
    if (selectedTag !== undefined) {
        if (selectedTag.type === TagType.Table &&
            selectedTag.jsonData !== null &&
            isTableTagJsonData(selectedTag.jsonData)) {
            try {
                for (var _o = __values(selectedTag.jsonData.headers), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var columnHeader = _p.value;
                    shownColumns.push({
                        type: TagEditorColumnType.Custom,
                        key: "custom-".concat(columnHeader.uniqueId),
                        readonly: columnHeader.type === CustomColumnType.FILE,
                        name: columnHeader.name,
                        uniqueId: columnHeader.uniqueId,
                        customColumnType: columnHeader.type,
                        getValue: customColumnGetValueMap[columnHeader.type](columnHeader.uniqueId),
                        applyChange: customColumnUpdateValuesMap[columnHeader.type](columnHeader.uniqueId),
                    });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_d = _o.return)) _d.call(_o);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    // consistent sort for connection columns (relations)
    function relationSort(a, b) {
        var aTag = tagData.tagById[a.connectedTableTagId];
        var bTag = tagData.tagById[b.connectedTableTagId];
        if (aTag === undefined || bTag === undefined) {
            // tags not found => use connection names
            return a.name.localeCompare(b.name);
        }
        if (aTag.ParentId === bTag.ParentId && aTag.order !== bTag.order) {
            // tags have same parent => use order property
            return aTag.order - bTag.order;
        }
        // tags don't have same parent => compare tag names
        return aTag.name.localeCompare(bTag.name);
    }
    var relations = (_g = (_f = tagData.relationsByTableTagId[selectedTagId !== null && selectedTagId !== void 0 ? selectedTagId : -1]) === null || _f === void 0 ? void 0 : _f.sort(relationSort)) !== null && _g !== void 0 ? _g : [];
    // consistent sort for connections in column
    function relationConnectionSort(a, b) {
        var aTag = tagData.tagById[a.connectedDimensionTagId];
        var bTag = tagData.tagById[b.connectedDimensionTagId];
        if (aTag === undefined || bTag === undefined) {
            // tags not found => sort by ids
            return a.connectedDimensionTagId - b.connectedDimensionTagId;
        }
        if (aTag.ParentId === bTag.ParentId && aTag.order !== bTag.order) {
            // tags have same parent => use order property
            return aTag.order - bTag.order;
        }
        // tags don't have same parent => compare tag names
        return aTag.name.localeCompare(bTag.name);
    }
    var _loop_1 = function (relation) {
        var e_5, _q, e_6, _r;
        var connectedTableTag = tagData.tagById[relation.connectedTableTagId];
        if (connectedTableTag === undefined) {
            return "continue";
        }
        try {
            for (var rows_1 = (e_5 = void 0, __values(rows)), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                var row = rows_1_1.value;
                var connectedTagColumn = {
                    tags: [],
                    parentTagId: connectedTableTag.id,
                };
                row.connectedTagColumns.push(connectedTagColumn);
                var thisRowConnections = tagData.relationConnectionsByKey.get("".concat(relation.tableTagId, "-").concat(relation.connectedTableTagId, "-").concat(row.id));
                if (!thisRowConnections) {
                    continue;
                }
                try {
                    for (var thisRowConnections_1 = (e_6 = void 0, __values(thisRowConnections)), thisRowConnections_1_1 = thisRowConnections_1.next(); !thisRowConnections_1_1.done; thisRowConnections_1_1 = thisRowConnections_1.next()) {
                        var connection = thisRowConnections_1_1.value;
                        var tag = tagData.tagById[connection.connectedDimensionTagId];
                        if (tag !== undefined && tag.ParentId === connectedTableTag.id) {
                            connectedTagColumn.tags.push(tag);
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (thisRowConnections_1_1 && !thisRowConnections_1_1.done && (_r = thisRowConnections_1.return)) _r.call(thisRowConnections_1);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (rows_1_1 && !rows_1_1.done && (_q = rows_1.return)) _q.call(rows_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        var getTagsToAddAndRemove = function (tagRowTagId, newConnectedTagIds) {
            var e_7, _a, e_8, _b;
            var tagConnectionsToAdd = [];
            var tagConnectionsToRemove = [];
            var processedTagIds = [];
            try {
                for (var _c = (e_7 = void 0, __values(relation.connections)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var connection = _d.value;
                    if (connection.dimensionTagId !== tagRowTagId) {
                        continue;
                    }
                    if (!newConnectedTagIds.includes(connection.connectedDimensionTagId)) {
                        tagConnectionsToRemove.push({
                            dimensionTagId: tagRowTagId,
                            connectedDimensionTagId: connection.connectedDimensionTagId,
                        });
                    }
                    processedTagIds.push(connection.connectedDimensionTagId);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_7) throw e_7.error; }
            }
            try {
                for (var newConnectedTagIds_1 = (e_8 = void 0, __values(newConnectedTagIds)), newConnectedTagIds_1_1 = newConnectedTagIds_1.next(); !newConnectedTagIds_1_1.done; newConnectedTagIds_1_1 = newConnectedTagIds_1.next()) {
                    var newConnectedTagId = newConnectedTagIds_1_1.value;
                    if (!processedTagIds.includes(newConnectedTagId)) {
                        tagConnectionsToAdd.push({
                            dimensionTagId: tagRowTagId,
                            connectedDimensionTagId: newConnectedTagId,
                        });
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (newConnectedTagIds_1_1 && !newConnectedTagIds_1_1.done && (_b = newConnectedTagIds_1.return)) _b.call(newConnectedTagIds_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
            return { tagConnectionsToAdd: tagConnectionsToAdd, tagConnectionsToRemove: tagConnectionsToRemove };
        };
        // add column
        shownColumns.push({
            type: TagEditorColumnType.Connection,
            key: "connection-".concat(connectedTableTag.id),
            readonly: false,
            getValue: function (tagRow) {
                var connectedTagsNames = relation.connections
                    .filter(function (connection) {
                    return connection.dimensionTagId === tagRow.tag.id &&
                        !!tagData.tagById[connection.connectedDimensionTagId];
                })
                    .sort(relationConnectionSort)
                    .map(function (connection) { return tagData.tagById[connection.connectedDimensionTagId].name; });
                return connectedTagsNames.join(', ');
            },
            getConnectedTags: function (tagRow) {
                var connectedTags = relation.connections
                    .filter(function (connection) {
                    return connection.dimensionTagId === tagRow.tag.id &&
                        !!tagData.tagById[connection.connectedDimensionTagId];
                })
                    .sort(relationConnectionSort)
                    .map(function (connection) { return tagData.tagById[connection.connectedDimensionTagId]; });
                return connectedTags;
            },
            getConnectedTagsIdsString: function (tagRow) {
                var connectedTagsIds = relation.connections
                    .filter(function (connection) { return connection.dimensionTagId === tagRow.tag.id; })
                    .map(function (connection) { return connection.connectedDimensionTagId; })
                    .sort(function (a, b) { return a - b; });
                return "".concat(relation.id).concat(KNOB_IDENTIFICATOR).concat(connectedTagsIds.join('|'));
            },
            applyChange: function (editTagData, newValue) {
                var e_9, _a;
                var _b;
                if (editTagData.id === undefined) {
                    // don't create connections for tags that aren't created yet
                    return;
                }
                var tagIdsToSet = [];
                if (newValue.includes(KNOB_IDENTIFICATOR)) {
                    var _c = __read(newValue.split(KNOB_IDENTIFICATOR), 2), relId = _c[0], newUsedValue = _c[1];
                    if (Number.parseInt(relId) === relation.id) {
                        var newConnectedTagIds = newUsedValue.trim() !== '' ? newUsedValue.split('|').map(function (i) { return Number.parseInt(i); }) : [];
                        tagIdsToSet.push.apply(tagIdsToSet, __spreadArray([], __read(newConnectedTagIds), false));
                    }
                }
                else {
                    var find = (_b = tagData.tagsByLowercase[newValue.toLowerCase()]) === null || _b === void 0 ? void 0 : _b.filter(function (t) { return t.ParentId === relation.connectedTableTagId; });
                    if (find !== undefined && find.length === 1) {
                        tagIdsToSet.push(find[0].id);
                    }
                    else {
                        var newValueSplit = newValue.split(', ');
                        try {
                            for (var newValueSplit_1 = (e_9 = void 0, __values(newValueSplit)), newValueSplit_1_1 = newValueSplit_1.next(); !newValueSplit_1_1.done; newValueSplit_1_1 = newValueSplit_1.next()) {
                                var name = newValueSplit_1_1.value;
                                var findSplit = tagData.tagsByLowercase[name.toLowerCase()];
                                if (findSplit !== undefined &&
                                    findSplit[0] !== undefined &&
                                    findSplit[0].ParentId === relation.connectedTableTagId) {
                                    tagIdsToSet.push(findSplit[0].id);
                                }
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (newValueSplit_1_1 && !newValueSplit_1_1.done && (_a = newValueSplit_1.return)) _a.call(newValueSplit_1);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                    }
                }
                var addAndRemove = getTagsToAddAndRemove(editTagData.id, tagIdsToSet);
                return addAndRemove;
            },
            relation: relation,
        });
    };
    try {
        // add CONNECTION columns
        for (var relations_1 = __values(relations), relations_1_1 = relations_1.next(); !relations_1_1.done; relations_1_1 = relations_1.next()) {
            var relation = relations_1_1.value;
            _loop_1(relation);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (relations_1_1 && !relations_1_1.done && (_e = relations_1.return)) _e.call(relations_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    // add button for adding new columns
    if (!hasAccountTags) {
        shownColumns.push({
            type: TagEditorColumnType.AddNewButton,
            key: 'add-new-button',
            readonly: true,
            getValue: function () { return ''; },
            applyChange: function () { return undefined; },
        });
    }
    var tagTable = {
        rows: rows,
        columns: shownColumns,
    };
    return {
        tagTable: tagTable,
        batchDeleteTagsHandler: batchDeleteTagsHandler,
        selectedTagId: selectedTagId,
        setSelectedTagId: setSelectedTagId,
        removeCustomColumn: removeCustomColumn,
        renameCustomColumn: renameCustomColumn,
    };
}
